import { MenuItem } from "@mui/material";
import {
  EditUserDataProps,
  EditUserProps,
  Participant,
} from "../../../interfaces/interfaces";

const EditUser = ({
  participant,
  setEditUser,
}: {
  participant: Participant;
  setEditUser: React.Dispatch<React.SetStateAction<EditUserProps>>;
}) => {
  return (
    <MenuItem
      disabled={participant.status === 1}
      onClick={() =>
        setEditUser({
          open: true,
          participant: participant as EditUserDataProps,
        })
      }
    >
      Nutzerdaten bearbeiten
    </MenuItem>
  );
};

export default EditUser;
